import React from 'react';

import IconRenderer from 'ui/icons/IconRenderer';
import type { IconProps } from 'ui/icons/IconRenderer';

import icon from './eye.svg';

const IconEye: React.FC<IconProps> = ({ className, style }) => (
  <IconRenderer
    iconHtml={icon}
    className={className}
    style={style}
  />
);

export default IconEye;
